import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import {Download} from 'lucide-react';
import {useLanguageStore} from "../store/languageStore";
import {api} from "../api/api";

export default function ProductPage() {
    const {language} = useLanguageStore();
    const isArabic = language === 'ar';

    const [product, setProduct] = useState({});


    const translations = {
        en: {
            title: 'Waterproofing Systems',
            description:
                'We provide comprehensive solutions covering project design and execution, from structural frameworks to final finishing, ensuring top-tier quality and efficiency. We provide comprehensive solutions covering project design and execution, from structural frameworks to final finishing, ensuring top-tier quality and efficiency.',
            recommended: 'Products You May Like',
            cardDesc:
                'We provide comprehensive waterproofing solutions for pools, basements, bathrooms, balconies, and all areas exposed to water and high moisture.',
            download: 'Download PDF File',
        },
        ar: {
            title: 'أنظمة العزل المائي',
            description:
                'نحن نقدم حلولًا شاملة تغطي تصميم وتنفيذ المشاريع، من الهياكل الأساسية إلى التشطيبات النهائية، مع ضمان الجودة والكفاءة العالية. نحن نقدم حلولًا شاملة تغطي تصميم وتنفيذ المشاريع، من الهياكل الأساسية إلى التشطيبات النهائية، مع ضمان الجودة والكفاءة العالية.',
            recommended: 'منتجات قد تعجبك',
            cardDesc:
                'نحن نقدم حلول عزل مائي شاملة للمسابح، والأقبية، والحمامات، والشرفات، وجميع المناطق المعرضة للماء والرطوبة العالية.',
            download: 'تحميل ملف PDF',
        },
    };

    const { id } = useParams();

    useEffect(() => {
        api.get(`products/${id}/`).then((res) => {
            console.log(res.data)
            setProduct(res.data)
        })
    }, [id])

    // Product card component
    const ProductCard = ({related_product}) => (
        <Link to={`/product/${related_product.id}`}>
        <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex flex-col h-full">
                <div className="flex justify-center mb-4">
                    <img loading="lazy"
                        src={related_product.image}
                        alt={related_product.name_en}
                        className="  w-full rounded-md "
                    />
                </div>
                <h3 className="font-bold text-lg mb-2 line-clamp-1">{isArabic ? related_product.name_ar : related_product.name_en}</h3>
                <p className="text-gray-600 text-sm line-clamp-2">{isArabic ? related_product.description_ar : related_product.description_en}</p>
            </div>
        </div>
        </Link>
    );

    return (
        <div className=" " dir={isArabic ? "rtl" : "ltr"}>
            {/* Product Detail Section */}
            <div className="max-w-6xl mx-auto px-4 py-16">
                <div className="flex flex-col md:flex-row gap-12">
                    {/* Product Image */}
                    <div className="md:w-1/3">
                        <img loading="lazy"
                            src={product.image}
                            alt={'image product'}
                            className="w-full"
                        />
                    </div>

                    {/* Product Info */}
                    <div className="md:w-2/3">
                        <div className="flex flex-col md:flex-row justify-between items-start mb-6">
                            <h1 className="text-3xl font-bold text-gray-800 mb-4 md:mb-0">
                                {isArabic ? product.name_ar : product.name_en}
                            </h1>
                            {product?.files?.length > 0 &&
                                <Link to={product?.files[0]?.file} target={'_blank'} download={true}>
                                    <button
                                        className="flex items-center gap-2 bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600 transition-colors">
                                        <Download size={18}/>
                                        <span>{isArabic && product.files.length > 0 ? 'تحميل ملف PDF' : 'Download PDF file'}</span>
                                    </button>
                                </Link>}
                        </div>

                        <p className="text-gray-600 leading-relaxed">{(isArabic ? product?.description_ar : product?.description_en)?.split('\r\n')
                            .map((line, index) => (<span key={index}>
                             {line}
                                <br/>
                         </span>))}
                        </p>
                    </div>
                </div>
            </div>

            {/* Recommended Products Section */}
            <div className="bg-gray-50 py-16">
                <div className="max-w-6xl mx-auto px-4">
                    <h2 className="text-2xl font-bold mb-10">{translations[language].recommended}</h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {product?.related_products?.map(related_product => (
                            <ProductCard key={related_product.id} related_product={related_product}/>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
